import { Stack, Box, useTheme } from "@mui/material"

export default function Scale({value, onChange}){

    const theme = useTheme();

    const off = {
        width: 24,
        height:24,
        fontSize: 14,
        borderRadius: '50%',
        border: 'solid 1px lightgrey',
        cursor: 'pointer'
    }

    const on = {...off, 
        color: 'white',
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main
    }

    return <Stack direction='row' spacing={0.6}>

        {[1,2,3,4,5,6,7,8,9,10].map(n => 
            <Stack 
                key={n}
                direction='row'
                justifyContent='center'
                alignItems='center'
                onClick={() => onChange(n)}
                sx={value === n ? on : off}
            >
                <Box>{n}</Box>
            </Stack>    
        )}

    </Stack>
}